import { render, staticRenderFns } from "./BaseTools.vue?vue&type=template&id=f4b2b700"
import script from "./BaseTools.vue?vue&type=script&lang=js"
export * from "./BaseTools.vue?vue&type=script&lang=js"
import style0 from "./BaseTools.vue?vue&type=style&index=0&id=f4b2b700&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports